import ToggleNav from './ToggleNav';
import ScrollTo from './ScrollTo';
import GoogleMap from './GoogleMap';
import Form from './Form';
import Tabs from './Tabs';
import Antispam from '../../components/Antispam'

const Components = {
    Antispam,
    ToggleNav,
    ScrollTo,
    GoogleMap,
    Form,
    Tabs
};

export default Components;


// WEBPACK FOOTER //
// ./components/index.js